module.exports = __webpack_public_path__ + "static/matthew-nest.2bf5b3c2.png";


//////////////////
// WEBPACK FOOTER
// ./matthew-nest.png
// module id = ./matthew-nest.png
// module chunks = 103038246049810